export const STATS = [
  // '월 세차 대수'(1,000+) 항목 제거 — 사장님 요청 (2026-06-18)
  { value: '98%', label: '고객 만족도', numericValue: 98, suffix: '%' },
  { value: '5년', label: '세차 경력', numericValue: 5, suffix: '년' },
];
